import { useEffect } from 'react';

export function useAutoAdjustTextareaRows(textareaId: string) {
  useEffect(() => {
    const textarea = document.getElementById(textareaId);
    const textareaElement = textarea as HTMLTextAreaElement;

    if (textarea) {
      textarea.addEventListener("input", () => {
        const textLength = textareaElement.value.length;
        const numRows = textLength > 130 ? 9 : 3;
        textareaElement.rows = numRows;
        textarea.scrollTop = textarea.scrollHeight;
      });
    }

    // Cleanup: remove event listener when component unmounts
    return () => {
      if (textarea) {
        textarea.removeEventListener("input", () => {});
      }
    };
  }, [textareaId]);
}
